import React, { useState } from 'react';
import { Minus, Plus, ShoppingCart } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { useCardEligibility } from '@/components/CardOrQuote';

export const AddToCart = ({ cartId, kind = 'catalogue', name, image, includes, eligibilityKey, eligibilityKind = 'products', dark = false, testId, className = '' }) => {
  const cart = useCart();
  const entry = useCardEligibility(eligibilityKey, eligibilityKind);
  const [quantity, setQuantity] = useState(1);
  const stepper = dark ? 'border-ei-white/30 text-ei-white' : 'border-ei-mist text-ei-navy';
  const quoteOnly = entry && !entry.card_payable;
  return <div className={className} data-testid={`${testId}-group`}>
    <div className="flex flex-wrap items-center gap-3">
      <div className={`inline-flex items-center rounded-sm border ${stepper}`}>
        <button type="button" aria-label="Reduce quantity" onClick={() => setQuantity((q) => Math.max(1, q - 1))} className="w-11 h-11 inline-flex items-center justify-center" data-testid={`${testId}-minus`}><Minus className="w-4 h-4" /></button>
        <span className="w-10 text-center text-sm font-bold tnum" data-testid={`${testId}-qty`}>{quantity}</span>
        <button type="button" aria-label="Increase quantity" onClick={() => setQuantity((q) => Math.min(50, q + 1))} className="w-11 h-11 inline-flex items-center justify-center" data-testid={`${testId}-plus`}><Plus className="w-4 h-4" /></button>
      </div>
      <button type="button" onClick={() => cart.add({ kind, id: cartId, name, image, includes, quantity })}
        className={`inline-flex items-center justify-center gap-2 rounded-sm px-6 py-4 min-h-[44px] font-display text-sm font-bold transition-colors ${dark ? 'bg-white text-ei-navy hover:bg-white/90' : 'bg-ei-navy text-white hover:bg-ei-navy/90'}`}
        data-testid={testId}>
        <ShoppingCart className="w-4 h-4" /> Add to cart
      </button>
    </div>
    {quoteOnly && <p className={`mt-2 text-xs leading-relaxed ${dark ? 'text-ei-white/60' : 'text-ei-graphite/65'}`} data-testid={`${testId}-quote-only`}>
      Quote only for now — you can keep it in your cart, but card payment is not available for this line.
    </p>}
  </div>;
};
